import React from "react";
import "./index.css";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import LocnLayout from "./layout/LocnLayout";
import DefaultLayout from "./layout/DefaultLayout";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";
import { createBrowserHistory } from "history";
import BangaloreWardsParksArea from "./components/maps/BangaloreWardsParksArea.js";
import BangaloreWards from "./components/maps/BangaloreWards.js";
import LocnBangaloreMap from "./components/maps/LocnBangaloreMap.js";
import LocnVVPuram from "./components/maps/LocnVVPuram";
import LocnIndiranagar from "./components/maps/LocnIndiranagar";
import LocnIndiranagarGrey from "./components/maps/LocnIndiranagarGrey";
import LocnFoodStreet from "./components/maps/LocnFoodStreet";
import H3ToLocnId from "./components/H3ToLocnId";
import { Toaster } from "react-hot-toast";
import { Navigate } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById("root"));

export const history = createBrowserHistory();

root.render(
  <React.StrictMode>
    <Router>
      <QueryParamProvider adapter={ReactRouter6Adapter}>
        <Routes>
        import { Navigate } from 'react-router-dom';
        <Route
            path="/"
            element={ <Navigate to="/locn-indiranagar" /> }
          />
          <Route
            path="/bangalore-parks"
            element={
              <DefaultLayout>
                <BangaloreWardsParksArea />{" "}
              </DefaultLayout>
            }
          />
          <Route
            path="/bangalore-wards"
            element={
              <DefaultLayout>
                <BangaloreWards />
              </DefaultLayout>
            }
          />

          <Route
            path="/locn-bangalore"
            element={
              <LocnLayout>
                <LocnBangaloreMap />
              </LocnLayout>
            }
          />
          <Route
            path="/locn-vvpuram"
            element={
              <LocnLayout>
                <LocnVVPuram />
              </LocnLayout>
            }
          />
          <Route
            path="/locn-foodstreet"
            element={
              <LocnLayout>
                <LocnFoodStreet />
              </LocnLayout>
            }
          />
          <Route
            path="/locn-indiranagar"
            element={
              <LocnLayout>
                <LocnIndiranagar />
              </LocnLayout>
            }
          />
          <Route
            path="/locn-indiranagar-grey"
            element={
              <LocnLayout>
                <LocnIndiranagarGrey />
              </LocnLayout>
            }
          />
          <Route
            path="/h3-to-locn-id"
            element={
              <LocnLayout>
                <H3ToLocnId></H3ToLocnId>
              </LocnLayout>
            }
          />
        </Routes>
      </QueryParamProvider>
      <Toaster position="bottom-center" reverseOrder={false} />
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
